<template lang="pug">
pr-wrapper#splash.flex-column.align-items-center.justify-content-center.h-100(fs bg zi=998)
  img(src="@/assets/images/software.png")
</template>

<script>
export default {
  name: "splash"
}
</script>

<style lang="scss" scoped>
#splash {
  display: flex;
}
</style>
